package com.wintermar.inspection.feature.presentation.splash

import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.setValue

class SplashState {
    var isLoading by mutableStateOf(true)
}
